<script setup lang="ts">
import { TooltipProvider } from 'reka-ui';
</script>

<template>
  <TooltipProvider>
    <slot />
  </TooltipProvider>
</template>
